import * as angular from 'angular';
import { GradPlanningWizardTableComponent } from './grad-planning-wizard-table.component';

export const GradPlanningWizardTableModule = angular
  .module('gradPlanningWizardTable', [])
  .component('gradPlanningWizardTable', GradPlanningWizardTableComponent).name;
